<template>
  <div
    :class="{
      'draggable': draggable,
      'clickable': !draggable
    }"
    class="border my-1 pl-1 d-flex justify-content-between no-select"
    :draggable="draggable"
    @dragstart="dragItem"
    @dblclick="selectMedia"
  >
    <div class="col-1 p-0 m-0"><i :class="`fas ${ setIcon(item.type) }`"></i></div>
    <div class="col-10 p-0 m-0"><small>{{ item.name }}</small></div>
    <div class="col-1 p-1">
      <a href="#" class="text-danger" @click.prevent="deleteMedia(item)"><i class="fa fa-trash"></i></a>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import Image from './../../../../viewer/Image'
import { mapActions } from 'vuex'

export default {
  components: {
    'image-viewer': Image
  },
  props: {
    item: {
      required: true
    },
    draggable: {
      default: true
    }
  },
  computed: {
    type: function () {
      return this.item.type.split('/')[0]
    }
  },
  methods: {
    ...mapActions({
      setDragging: 'setDragging'
    }),

    setIcon: function (completeType) {
      let type = completeType.split('/')[0]
      if ( type === "video" ) {
        return "fa-video"
      } else if ( type == "image") {
        return "fa-image"
      } else if ( type == "application") {
        return "fa-file"
      }
    },

    deleteMedia: function (item) {
      Axios.delete(`/teacher/course/media/${ item.id }`)
        .then( res => {
          this.$emit('reload')
        })
    },

    dragItem: function ( $e ) {
      this.setDragging( this.item )
      $e.dataTransfer.dropEffect = 'copy'
      $e.dataTransfer.setData( "media", this.item )
    },

    selectMedia: function () {
      this.$emit('selectMedia', this.item)
    }
  },
}
</script>
